import { ConversionUnits } from "./conversion-unit.models";
import { ListaPrecio } from "./listaprecio.models";
import { Variante } from "./variante.models";
import { Voucher } from "./voucher.models";

export class Detail {
  id?: number;
  voucherId: number;
  code?: string;
  description?: string;
  type: string;
  variantId: number;
  quantity: number;
  unitPrice: number;
  bonus?: number;
  bonusAmount?: number;
  subtotalWithIva: number;
  subtotal: number;
  batch?: string;
  conversionUnitId?: number;
  conversionUnits?: ConversionUnits[];
  measurementUnitId?: number;
  
  // Nuevos campos de la entidad
  createdAt?: Date;
  updatedAt?: Date;
  deletedAt?: Date;
  date?: string;

  // Opcional: relaciones
  variant?: Variante;
  priceList?: ListaPrecio;
  vouchers?: Voucher[];
}
